import { FC } from 'react';

import { TeamHeading } from '@/components/Layout/Parts';

import DistributionVideoTable from './components/DistributionVideoTable';

interface Props {
  isProjectSummary?: boolean;
}

const DistributionVideoSummary: FC<Props> = ({ isProjectSummary }) => {
  return (
    <>
      <TeamHeading />
      <DistributionVideoTable isProjectSummary={isProjectSummary} />
    </>
  );
};

export default DistributionVideoSummary;
